<template>
  <div class="button-group" >
    <v-btn color="valid"
           @click="$emit('save')">
      {{ $t('components.formMCQ.buttons.save.name') }}
    </v-btn>
    <v-btn v-if="!isModification && !justSave" @click="$emit('save', 'New')"
           color="other1"
    >
      {{ $t('components.formMCQ.buttons.saveNew.name') }}
    </v-btn>
    <v-btn v-if="!justSave" @click="$emit('save', 'Continue')"
           color="other2"
    >
      {{ $t('components.formMCQ.buttons.saveContinue.name') }}
    </v-btn>
    <v-btn color="cancel" @click="cancel">
        {{ $t('components.formMCQ.buttons.cancel.name') }}
    </v-btn>
  </div>
</template>

<script>

export default {
  name: 'saveButtons',
  props: {
    isModification: {
      required: true,
      type: Boolean
    },
    justSave: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel () {
      this.$router.push({ name: 'questionsList' })
    }
  }
}

</script>

<style lang="scss" scoped>
  .button-group {
    margin-top: 30px;
    display: flex;
    flex-direction: column;

    .v-btn{
      margin: 6px 30px;
    }
  }
</style>
